import classes from "./UserProfile.module.css";
import GroupManagement from "./GroupManagement/GroupManagement";
import React from "react";
import FadingList from "../FadingList/FadingList";

export default function GroupList({groups, userId, selectedUser, accountId, isUserProfileView}) {

    const groups_jsx = groups && groups.length > 0 ? groups.map( group => {
        const manager_jsx = group.group_manager && userId === selectedUser ? (<div>Group Manager — </div>) : '';
        //const group_type_name = (group.group_type_name ? group.group_type_name.toLowerCase() : '');
        //const group_text = group.group_id ? group.group_user_type_name + member_text +' the '+ group_type_name +' '+ group.group_name +'.' : '';
        const
            group_members_jsx =  (group.group_manager && userId === selectedUser) ? (
                <div className={classes.UserItem}>
                    <div className={classes.UserLabel}>Group Members:</div>
                    <div>
                        <GroupManagement
                            account_id={accountId}
                            group_id={group.group_id}
                        />
                    </div>
                </div>
            ) : '';

        return (
            <div className="user-profile-box" key={group.group_id + "user_profile"}>
                <div className="user-profile-title-box">
                    <div className={classes.UserLabel}>{group.group_name}</div>
                </div>
                <div className="user-profile-groups-body">
                    <div className={classes.UserItem}>
                        <div className={classes.UserLabel}>Group Type:</div>
                        <div>{group.group_type_name}</div>
                    </div>
                    {isUserProfileView ? <div className={classes.UserItem}>
                        <div className={classes.UserLabel}>Group Role:</div>
                        {manager_jsx}
                        <div>{group.group_user_type_name}</div>
                    </div> : ''}
                    {group_members_jsx}
                </div>
            </div>
        );
    }) : null;

    const groups_to_list = groups_jsx ? groups_jsx.map( (group, index) => {
        return (<li key={index + "user_groups_list"} className="user-profile-list-no-margin">{group}</li>);}) : null

    return !isUserProfileView ? groups_to_list : <FadingList initialHeight={300} mutable={false}>{groups_to_list}</FadingList>;

}